import { isDate } from 'date-fns';
import { formatIntl } from './format-date';
import type { FormatIntlParams } from './types';

const isDateRange = (value: unknown): value is { end: Date | string; start: Date | string } =>
  typeof value === 'object' && value !== null && 'end' in value && 'start' in value;

export const DEFAULT_INVALID_DATE = '-';

export const formatIntlDateOrRangeValue = ({
  lang,
  type,
  value,
}: {
  lang?: FormatIntlParams['lang'];
  type: FormatIntlParams['type'];
  value: unknown;
}) => {
  if (isDateRange(value)) {
    return formatIntl({
      end: value.end,
      lang,
      start: value.start,
      type,
    });
  }

  if (isDate(value)) {
    return formatIntl({
      lang,
      start: value,
      type,
    });
  }

  return DEFAULT_INVALID_DATE;
};
